"use client";

import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Linkedin, Instagram, Facebook, MessageCircle, X } from "lucide-react";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="209188" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackServices = ["Desarrollos Inmobiliarios", "Construcción Premium", "Inversiones Estratégicas"];
    return <ul className="flex flex-col gap-3 text-sm text-muted-foreground/60 font-default">
        {fallbackServices.map((service, i) => <li key={i} data-index={i}>
            <Link to="#" className="hover:text-foreground transition-colors duration-200">
              {service}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3 text-sm text-muted-foreground/60 font-default">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="hover:text-foreground transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function PieDePaginaApex() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  return <>
      <style dangerouslySetInnerHTML={{
      __html: `
        #pie-de-página form label,
        #pie-de-página form input,
        #pie-de-página form textarea,
        #pie-de-página form input::placeholder,
        #pie-de-página form textarea::placeholder {
          color: #ffffff !important;
        }
      `
    }} />
      <section id="pie-de-página" className="dark text-foreground pt-16 pb-8 !bg-[hsl(0,0%,96%)]">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
            
            <div className="flex flex-col gap-10">
              {}
              <div className="flex flex-col gap-6">
                <Link to="/" className="inline-block w-fit">
                  <img src="https://rudichgroup.redian.com.ar/wp-content/uploads/2026/04/VillaUrquizaAltoaguirre2114.png" alt="Rudich Group Argentina" className="h-16 w-auto" />
                </Link>
                <div className="flex flex-col gap-3 text-sm text-muted-foreground/60 font-default">
                  <div className="flex items-start gap-3 group">
                    <MapPin className="size-4 shrink-0 mt-0.5 text-primary transition-colors" />
                    <span className="group-hover:text-foreground transition-colors duration-200 !text-[hsl(203,55%,13%)]">
                      Sede Central: Buenos Aires, Argentina<br />
                      Proyectos en toda la región
                    </span>
                  </div>
                  <div className="flex items-center gap-3 group !text-[hsl(203,55%,13%)]">
                    <Phone className="size-4 shrink-0 text-primary transition-colors" />
                    <span className="group-hover:text-foreground transition-colors duration-200 !text-[hsl(203,55%,13%)]">+54 11 3384 1271</span>
                  </div>
                  <div className="flex items-center gap-3 group !text-[hsl(0,0%,0%)]">
                    <Mail className="size-4 shrink-0 text-primary transition-colors" />
                    <span className="group-hover:text-foreground transition-colors duration-200 !text-[hsl(203,55%,13%)]">contacto@rudichgroup.com.ar</span>
                  </div>
                  <div className="mt-4">
                    <img src="https://rudichgroup.redian.com.ar/wp-content/uploads/2026/06/designedchico.png" alt="Designed by Redian" className="h-10 w-auto" loading="lazy" />
                  </div>
                </div>
              </div>

              {}
              
              

              {}
              
              

              {}
              <div className="flex flex-col gap-6">
                
                
                <div className="flex gap-3">
                  <Button variant="outline" size="icon" asChild className="bg-transparent border-border/20 text-muted-foreground/60 hover:text-[#0077b5] hover:border-[#0077b5] hover:bg-[#0077b5]/10 transition-all">
                    
                  </Button>
                  <Button variant="outline" size="icon" asChild className="bg-transparent border-border/20 text-muted-foreground/60 hover:text-[#e4405f] hover:border-[#e4405f] hover:bg-[#e4405f]/10 transition-all">
                    
                  </Button>
                  <Button variant="outline" size="icon" asChild className="bg-transparent border-border/20 text-muted-foreground/60 hover:text-[#1877f2] hover:border-[#1877f2] hover:bg-[#1877f2]/10 transition-all">
                    
                  </Button>
                </div>
                <p className="text-xs font-default italic mt-2 !text-[hsl(0,0%,0%)]"><br /></p>
              </div>
            </div>

          <div style={{
            border: '2px solid #e6cd93',
            borderRadius: '16px',
            padding: '3px'
          }}>
  <div style={{
              borderRadius: '12px',
              overflow: 'hidden'
            }}>
    <iframe src="https://www.google.com/maps/d/embed?mid=1VzH1Iz3RCINtieytmIt1tkQxG4PDTqM&ehbc=2E312F&noprof=1" width="100%" height="300" style={{
                border: 0,
                display: 'block'
              }} loading="lazy"></iframe>
  </div>
          </div>

          </div>

          {}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-[12px] text-muted-foreground/60 font-default">
            <p className="!text-[hsl(203,55%,13%)]">© 2026 Rudich Group. Todos los derechos reservados.</p>
            <Badge variant="outline" className="inline-flex items-center justify-center rounded-md border text-xs w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground bg-transparent border-border/20 font-normal tracking-widest py-1 px-3 uppercase !text-[hsl(203,55%,13%)] dark:aria-invalid:ring-destructive/40">
              Excelencia en Construcción
            </Badge>
          </div>
        </div>
      </section>
      
      {}
      {isChatOpen && <div className="fixed bottom-24 right-8 z-50 w-80 bg-background border border-border shadow-2xl overflow-hidden rounded-2xl flex flex-col animate-in fade-in slide-in-from-bottom-4 duration-300">
          <div className="bg-[#075e54] p-4 text-white flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="size-10 rounded-lg bg-white flex items-center justify-center p-1.5 overflow-hidden shadow-sm">
                <img src="/img/LOGO-VERSION-HORIZONTAL.png" alt="Rudich Group" className="w-full h-auto" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-sm leading-none">Rudich Group</span>
                <span className="text-[10px] opacity-80 mt-0.5">Desarrollo, innovación y legado</span>
              </div>
            </div>
            <Button variant="ghost" size="icon" onClick={() => setIsChatOpen(false)} className="size-8 text-white hover:bg-white/10 rounded-lg">
              <X className="size-4" />
            </Button>
          </div>
          
          <div className="bg-[#e5ddd5] p-4 min-h-[120px] flex flex-col justify-end">
            <div className="bg-white p-3 rounded-lg rounded-tl-none text-sm text-foreground shadow-sm relative max-w-[85%]">
              <p>Hola, ¿en qué podemos ayudarte?</p>
              <span className="text-[9px] text-muted-foreground block text-right mt-1">
                {new Date().toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit'
            })}
              </span>
            </div>
          </div>

          <div className="p-4 bg-background">
            <Button asChild className="w-full bg-[#e6cd93] hover:bg-[#e6cd93] text-white hover:text-white h-11 font-bold text-xs uppercase tracking-widest transition-all duration-300 shadow-md hover:shadow-lg border-none">
              <Link to="https://wa.me/5491133841271" newTab>COMENZAR CONVERSACIÓN</Link>
            </Button>
          </div>
        </div>}

      
    </>;
}